/*
 Auto-generated by generate-java-to-ts-maven-plugin. Do not edit.
 Source: de.mhus.vance.api.question.QuestionKind
*/
export var QuestionKind;
(function (QuestionKind) {
    QuestionKind["CHOICE"] = "CHOICE";
    QuestionKind["TEXT"] = "TEXT";
    QuestionKind["CONFIRM"] = "CONFIRM";
})(QuestionKind || (QuestionKind = {}));
//# sourceMappingURL=QuestionKind.js.map